<template>
  <!-- 关于我们 -->
  <div id="aboutUs">
    <herder-img :imgs="imgs"></herder-img>
    <!-- 关于中税 -->
    <div class="about">
      <h1 class="about-h1">关于中税</h1>
      <div class="about-cont">
        <div class="cont-text">
          <p>&emsp;&emsp;浙江中税成立于2010年，是一家是专业化、规模化的财税代理企业。2015年起入驻杭州市经济技术开发区行政服务中心，立足开发区，辐射大杭州，在杭州市各城区设置多个分址。</p>
          <p>&emsp;&emsp;公司旗下设中税税务师事务所、 中税会计事务所 、中税教育科技、 中税商务秘书，系综合性财税类专业代理机构。</p>
          <p>&emsp;&emsp;公司提供审计报告、税收合规安排、高新专项、离任审计、注册注销、法定地址挂靠、代理记账、税务培训等相关服务,满足客户多样化、个性化需求。</p>
          <p>&emsp;&emsp;公司拥有由注册会计师、税务师、评估师、审计师等行业高端人才组成的高素质专业团队，恪守“独立、高效、诚信、保密"的原则，以统-的执业标准和质量控制，为客户提供全面、专业、系统的财税咨询及审计服务,获得了客户的广泛赞誉。</p>
          <p>&emsp;&emsp;公司携手浙江财经大学等省内高校，获经济学国家级实习基地荣誉,为税务、会计专业的学生们提供教育实践机会，为社会孵化更多专业人才。</p>
          <p>&emsp;&emsp;我们将秉承“内诫于心、外信于人”的宗旨,做企业身边的财税专家，真诚服务客户、尽心成就员工、积极回报社会，努力成为国内一流财税专业服务机构。</p>
          <p>&emsp;&emsp;公司入驻杭州市经济技术开发区行政服务中心，以及为杭州市高科技孵化园区、梦想小镇、人工智能小镇、阿里创业园区等众多知名园区提供财税专业配套服务。</p>
        </div>
        <div class="cont-img">
          <img src="./images/guan001.png" alt="">
        </div>
      </div>
    </div>
    <!-- 发展历程 -->
    <div class="development">
      <h1 class="development-h1">发展历程</h1>
      <div class="development-cont">
        <div class="cont-item" v-for="item of deveList" :key="item.text">
          <div class="item-tim">
            <!-- <p>{{item.month}}</p> -->
            <h4>{{item.year}}</h4>
          </div>
          <div class="item-text">
            <p>{{item.text}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 荣誉和资质 -->
    <div class="honor">
      <h1 class="honor-h1">荣誉和资质</h1>
      <div class="honor-cont">
        <div class="cont-left">
          <div class="items-cont">
            <div class="item" v-for="item of honor" :key="item">
              <img src="./images/组 2756.png" alt />
              <span>—&ensp;</span>
              <span>{{item}}</span>
            </div>
          </div>
        </div>
        <div class="cont-right">
          <img src="./images/25.png" alt />
        </div>
      </div>
    </div>
    <!-- 中税宣传片 -->
    <div class="video">
      <div class="video-bgt">
        <img src="./images/重复网格 1.png" alt />
      </div>
      <div class="video-cont">
        <h1 class="video-cont-h1">中税宣传片</h1>
        <div class="cont-in">
          <video
            @click="opVidoe"
            ref="videoPlay"
            width="100%"

            poster="./images/组 2950.png"
            src="http://zhongshui.365hy.com/ZHONG/image/2020promotionalVideo.mp4"
          >
            <!-- <source > -->
          </video>
          <img
            @click="opVidoe"
            v-if="initialize && !isPlay"
            class="video-play"
            src="./images/播放_bg.png"
            alt
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HerderImg from "@/common/herder-img";
export default {
  name: "aboutUs",
  data() {
    return {
      imgs: require("./images/组 2949.png"),
      deveList: [
        {
          month: "10-12",
          year: 2010,
          text: "成立杭州中税财务咨询有限公司"
        },
        {
          month: "03-12",
          year: 2016,
          text: "财务公司变更为浙江中税财务咨询有限公司（注册资金1000万）"
        },
        {
          month: "11-12",
          year: 2011,
          text: "成立杭州中税税务师事务所（普通合伙）"
        },
        {
          month: "01-12",
          year: 2018,
          text: "成立杭州中税会计师事务所（普通合伙）"
        },
        {
          month: "01-12",
          year: 2015,
          text: "成立杭州中税教育科技有限公司"
        },
        {
          month: "06-12",
          year: 2018,
          text: "税务师事务所（普通合伙）改制为杭州中税税务师事务所有限公司"
        },
        {
          month: "07-12",
          year: 2015,
          text: "成立杭州中税商务秘书有限公司"
        },
        {
          month: "03-12",
          year: 2020,
          text: "财务公司推出财务单据智能记账，报表数据在线查询功能"
        }
      ],
      honor: [
        "经浙江省税务局批准具有税务鉴证及税务服务资格",
        "经浙江省财政厅批准具有审计、咨询、代理记账等服务资格",
        "经济学国家级实践基地",
        "杭州市创新券使用指定服务机构",
        "中国注册税务师协会会员单位",
        "中国注册会计师协会会员单位",
        "浙江省消费者品牌满意单位",
        "中国电子商务协会诚信认证单位",
        "杭州市纳税人权益保护协会会员",
        "浙江省中小企业公告服务平台会员",
        "浙大校友企业家执行会长单位"
      ],
      isPlay: false,
      initialize: false
    };
  },
  updated() {
    this.$nextTick(function() {
      // Code that will run only after the
      // entire view has been re-rendered
      // console.log(111)
      // let name = this.$refs.names;
      // console.log(name);
    });
  },
  components: {
    HerderImg
  },
  methods: {
    // ockike() {
    //   // let name = this.$refs.names;
    //   // console.log(name);
    //   this.oks = 2;
    //   console.log(this.oks);
    // }
    opVidoe(e) {
      let videoPlay = this.$refs.videoPlay;
      if (!this.isPlay) {
        videoPlay.play();
      } else {
        videoPlay.pause();
      }
      this.isPlay = !this.isPlay;
      this.initialize = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.about {
  // width: 100%;
  // padding: 50px 10%;
  width: 1040px;
  margin: 50px auto;
  box-sizing: border-box;
  .about-h1 {
    margin-bottom: 30px;
  }
  .about-cont {
    padding: 20px;
    border: 1px solid #ccc;
    line-height: 31px;
    font-size: 16px;
    display: flex;
    .cont-text {
      flex: 1;
    }
    .cont-img {
      flex: 0.5;
      padding-left: 30px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.development {
  // width: 100%;
  // padding: 0 10%;
  width: 1040px;
  margin: 0 auto;
  box-sizing: border-box;
  .development-cont {
    display: flex;
    justify-content: space-between;
    flex-flow: wrap;
    padding: 20px 0 40px 0;
    .cont-item {
      width: 48%;
      border-bottom: 1px solid #dfdfdf;
      display: flex;
      font-size: 13px;

      .item-tim {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 10px 0;
        border-right: 1px dotted #cccccc;
        h4 {
          font-size: 14px;
        }
      }
      .item-text {
        flex: 5;
        display: flex;
        align-items: center;
        margin-left: 10px;
      }
    }
  }
}
// 荣誉和资质
.honor {
  width: 100%;
  padding: 40px 0;
  min-width: 1040px;
  box-sizing: border-box;
  background-color: rgb(238, 238, 238);
  .honor-h1 {
    width: 1040px;
    margin: 0px auto;
    margin-bottom: 30px;
  }
  .honor-cont {
    width: 1040px;
    margin: 0px auto;
    display: flex;
    padding: 10px;
    background-color: #ffffff;
    box-sizing: border-box;
    .cont-left {
      flex: 4;
      margin: 10px 0 10px 20px;
      .items-cont {
        .item {
          height: 35px;
          font-size: 13px;
          display: flex;
          align-items: center;
          color: #5d5d5d;
          img {
            width: 18px;
            height: 21px;
            margin-right: 5px;
          }
        }
      }
    }
    .cont-right {
      flex: 4;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
// 宣传片
.video {
  width: 100%;
  min-width: 1040px;
  position: relative;
  .video-bgt {
    position: relative;
    img {
      width: 100%;
    }
  }
  .video-cont {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    .video-cont-h1 {
      padding: 30px 0;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .video-cont-h1::after {
      content: "";
      width: 50px;
      height: 4px;
      border-radius: 2px;
      background: #ffffff;
      display: block;
      margin-top: 20px;
    }
    .cont-in {
      position: relative;
      width: 50%;
      .video-play {
        width: 50px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -25px;
        margin-left: -25px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/aboutUs/aboutUs.vue